/*
 * Customs User Auth Management Screen
 * !== 세관 사용자 권한 관리 화면 ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
import { ptlEnvs } from "@/tra/tancis/ptli/comn";
import { comnUtils } from "@/comn/utils";
import { api } from "@/comn";
import { TFormSchema, TGridSchema } from "@/comn/hooks";

export const BASE = {
    path: `${ptlEnvs.base}/ptl/cstm-auth`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/ptl/cstm-auth/mgmt`,
    nodes: [],
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    getCstmUsrList: (data: any, page: number, size: number) =>
        api.get(`${BASE.api}/cstm-usr?page=${page}&size=${size}`, { params: comnUtils.toGetParams(data) }),
    getCstmUsrAuthList: (data: any) => api.get(`${BASE.api}/cstm-auth/${data.usrDmnId}`),
    getAuthList: (data: any, page: number, size: number) =>
        api.get(`${BASE.api}/auth?page=${page}&size=${size}`, { params: comnUtils.toGetParams(data) }),
    getComboList: (data: any) => api.get(`${BASE.api}/combo`, { params: comnUtils.toGetParams(data) }),
    saveCstmUsrAuthList: (data: any) => api.post(`${BASE.api}`, data),
    // Get a excel list of Customs staff. !== 세관 직원 엑셀 목록을 조회한다. ==!
    getCstmUsrExcelList: (data: any) => api.get(`${BASE.api}/cstm-usr/excel`, { params: comnUtils.toGetParams(data) }),

    // saveExcelDownload: (downurl: any, params: any) => {
    //     api.post(downurl, params, { responseType: "blob" })
    //         .then((response): void => {
    //             const blob: Blob = new Blob([response.data], { type: response.headers["content-type"] });
    //             const contentDisposition = response.headers["content-disposition"];
    //             let fileName: string = "exceldown.xlsx";
    //             if (contentDisposition) {
    //                 const fileNameMatch = contentDisposition.split(";").filter(function (str: any) {
    //                     return str.includes("filename");
    //                 });
    //                 if (fileNameMatch && fileNameMatch.length > 0) {
    //                     const arrFileNameMatch = fileNameMatch[0].split("=");
    //                     if (arrFileNameMatch != null && arrFileNameMatch.length > 1) {
    //                         fileName = arrFileNameMatch[1];
    //                     }
    //                 }
    //             }
    //             fileName = decodeURI(fileName).replaceAll('"', "");
    //             if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
    //                 // IE10 +
    //                 (window.navigator as any).msSaveOrOpenBlob(blob, fileName);
    //             } else {
    //                 // not ie
    //                 const link = document.createElement("a");
    //                 link.href = window.URL.createObjectURL(blob);
    //                 link.setAttribute("download", fileName);
    //                 link.style.cssText = "display:none";
    //                 link.target = "_self";
    //                 document.body.appendChild(link);
    //                 link.click();
    //                 link.remove();
    //             }
    //         })
    //         .catch((error) => {
    //             throw error;
    //         });
    // },
};

export const URLS = {
    ptli1007001q: `${BASE.path}/ptli1007001q`, // Custom Office User Auth Management List !== 세관 사용자 권한 관리 목록 ==!
    ptli1007002s: `${BASE.path}/ptli1007002s`, // Save. Custom Office User Auth Data !== 세관 사용자 권한 저장. ==!
};

export const SF_CSTMSAUTH_SRCH: TFormSchema = {
    id: "form_cstmAuthSrch",
    schema: {
        usrDmnId: { type: "text", label: "L_USR_DMN_ID" },
        cstmOfcrNo: { type: "text", label: "L_CSTM_OFCR_NO" },
        cstmCd: { type: "code", label: "L_CSTM_OFCE", area: "cstmCd", popupSize: "md" },
        cstmOfcrNm: { type: "text", label: "L_NM" },
        authId: { type: "text", label: "L_AUTH_ID" },
        authNm: { type: "text", label: "L_AUTH_NM" },
        usrStatCd: { type: "select", label: "L_STTS", all: true, area: "comnCd", comnCd: "PTL0001" },
    },
};

export const SF_AUTH_SRCH: TFormSchema = {
    id: "form_authSrch",
    schema: {
        usrDmnId: { type: "text" },
        authId: { type: "text", label: "L_AUTH_ID" },
        authNm: { type: "text", label: "L_AUTH_NM" },
    },
};

export const SF_CSTM_OFCR_INFO: TFormSchema = {
    id: "form_cstmOfcrInfo",
    schema: {
        sctnNm: { type: "text", label: "L_SCTN", labelSize: 2, controlSize: 2, edit: false },
        cstmNm: { type: "text", label: "L_CSTM_OFCE", labelSize: 2, controlSize: 2, edit: false },
        unitNm: { type: "text", label: "L_UT", labelSize: 2, controlSize: 2, edit: false },
        usrDmnId: { type: "text", label: "L_USR_DMN_ID", labelSize: 2, controlSize: 2, edit: false },
        cstmOfcrNo: { type: "text", label: "L_CSTM_OFCR_NO", labelSize: 2, controlSize: 2, edit: false },
        usrNm: { type: "text", label: "L_CSTM_OFCR_NM", labelSize: 2, controlSize: 2, edit: false },
        usrTelno: { type: "text", label: "L_TELNO", edit: false },
        usrEmlAddr: { type: "text", label: "L_EML_ADDR", edit: false },
    },
};

export const SG_CSTM_USR_LIST: TGridSchema = {
    id: "grid_cstmUsrList",
    options: { index: true, pagination: "out" },
    head: [
        { cells: [{ header: "L_USR_NM", binding: "usrNm", width: "0.8*" }] },
        { cells: [{ header: "L_USR_DMN_ID", binding: "usrDmnId", width: "0.8*" }] },
        { cells: [{ header: "L_CSTM_OFCR_NO", binding: "cstmOfcrNo", width: "0.8*" }] },
        { cells: [{ header: "L_SCTN", binding: "sctnNm", width: "1.5*" }] },
        { cells: [{ header: "L_CSTM", binding: "cstmNm", width: "1.5*" }] },
        { cells: [{ header: "L_UT_CD", binding: "unitNm", width: "1.5*" }] },
        { cells: [{ header: "L_USR_STAT", binding: "usrStatCdNm", width: "10%" }] },
    ],
    body: [
        { cells: [{ binding: "usrNm", align: "left" }] },
        { cells: [{ binding: "usrDmnId", align: "left" }] },
        { cells: [{ binding: "cstmOfcrNo" }] },
        { cells: [{ binding: "sctnNm", align: "left" }] },
        { cells: [{ binding: "cstmNm", align: "left" }] },
        { cells: [{ binding: "unitNm", align: "left" }] },
        { cells: [{ binding: "usrStatCdNm" }] },
    ],
};

export const SG_CSTM_USR_AUTH_LIST: TGridSchema = {
    id: "grid_cstmUsrAuthList",
    options: { checkbox: true },
    head: [
        { cells: [{ header: "L_ROLE_NM", binding: "roleId", width: "30%" }] },
        { cells: [{ header: "L_AUTH_ID", binding: "authId", width: "15%" }] },
        { cells: [{ header: "L_AUTH_NM", binding: "authNm", width: "*" }] },
        { cells: [{ header: "roleTyCd", binding: "roleTyCd", width: "*" }], show: false },
    ],
    body: [
        { cells: [{ binding: "roleId", align: "center" }] },
        { cells: [{ binding: "authId", align: "center" }] },
        { cells: [{ binding: "authNm", align: "left" }] },
        { cells: [{ binding: "roleTyCd", align: "left" }] },
    ],
};

export const SG_SCRH_AUTH_LIST: TGridSchema = {
    id: "grid_srchAuthList",
    options: { index: true, checkbox: true, pagination: "out", height: 150 },
    head: [
        { cells: [{ header: "L_AUTH_ID", binding: "authId", width: "*" }] },
        { cells: [{ header: "L_AUTH_NM", binding: "authNm", width: "*" }] },
        { cells: [{ binding: "isRgsrYn", width: "*" }], show: false },
    ],
    body: [
        { cells: [{ binding: "authId", align: "center" }] },
        { cells: [{ binding: "authNm", align: "left" }] },
        { cells: [{ binding: "isRgsrYn", align: "center" }] },
    ],
};

export const SG_CSTM_USR_EXCEL_LIST: TGridSchema = {
    id: "grid_cstmUsrExcelList",
    options: { index: true, pagination: "out" },
    head: [
        { cells: [{ header: "L_USR_NM", binding: "usrNm", width: "0.8*" }] },
        { cells: [{ header: "L_USR_DMN_ID", binding: "usrDmnId", width: "0.8*" }] },
        { cells: [{ header: "L_CSTM_OFCR_NO", binding: "cstmOfcrNo", width: "0.8*" }] },
        { cells: [{ header: "L_SCTN", binding: "sctnNm", width: "1.5*" }] },
        { cells: [{ header: "L_CSTM", binding: "cstmNm", width: "1.5*" }] },
        { cells: [{ header: "L_UT_CD", binding: "unitNm", width: "1.5*" }] },
        // { cells: [{ header: "L_ROLE_NM", binding: "roleId", width: "30%" }] },
        // { cells: [{ header: "L_AUTH_ID", binding: "authId", width: "15%" }] },
        // { cells: [{ header: "L_AUTH_NM", binding: "authNm", width: "*" }] },
        // { cells: [{ header: "roleTyCd", binding: "roleTyCd", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "usrNm", align: "left" }] },
        { cells: [{ binding: "usrDmnId", align: "left" }] },
        { cells: [{ binding: "cstmOfcrNo" }] },
        { cells: [{ binding: "sctnNm", align: "left" }] },
        { cells: [{ binding: "cstmNm", align: "left" }] },
        { cells: [{ binding: "unitNm", align: "left" }] },
        // { cells: [{ binding: "roleId", align: "center" }] },
        // { cells: [{ binding: "authId", align: "center" }] },
        // { cells: [{ binding: "authNm", align: "left" }] },
        // { cells: [{ binding: "roleTyCd", align: "left" }] },
    ],
};
